
import request from '../../request';

function initPaymentState() {
  return {
    loading: false,
    loaded: false,
    data: [],
  };
}

export default {
  namespaced: true,
  state: initPaymentState(),
  mutations: {
    setLoading(state, loading) {
      Object.assign(state, { loading });
    },
    setLoaded(state, loaded) {
      Object.assign(state, { loaded });
    },
    setData(state, data) {
      Object.assign(state, { data });
    },

  },

  actions: {
    get(context) {
      return new Promise((resolve) => {
        context.commit('setLoading', true);
        request.make({
          type: 'GET',
          url: `${process.env.API_URL}transactions`,
        }, (err, res) => {
          context.commit('setLoading', false);
          if (res.status === 200) {
            context.commit('setData', res.body.data);
            context.commit('setLoaded', true);
            resolve();
          }
        });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/admin/payments.js